import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import { formatEta } from "../../utils/poseTimeline";
import "./poseOverlays.css";

export function PoseProcessingOverlay({
  progress = 0,
  etaSeconds = null,
  message,
}) {
  const { t } = useTranslation();
  const pct = Math.round(Math.min(100, Math.max(0, progress * 100)));
  const etaLabel = formatEta(etaSeconds);

  return (
    <div className="pose-processing-overlay" role="status" aria-live="polite">
      <div className="pose-processing-overlay__card">
        <Loader2
          className="pose-processing-overlay__spinner"
          size={28}
          strokeWidth={2.4}
          aria-hidden
        />
        <p className="pose-processing-overlay__message">
          {message ||
            t("poseAnalyzingServer", "Analyzing pose on server…")}
        </p>
        <div className="pose-processing-overlay__bar-track">
          <div
            className="pose-processing-overlay__bar-fill"
            style={{ width: `${pct}%` }}
          />
        </div>
        <p className="pose-processing-overlay__meta">
          {pct}%
          {etaLabel ? ` · ${etaLabel}` : ""}
        </p>
      </div>
    </div>
  );
}

export default PoseProcessingOverlay;
